import { useMemo, useState, useRef } from "react";
import "./Filter.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "../../../../features/auth/AuthContext";
import api from "../../../../api/api"
import { arrowForward, autorenew } from "../../../../assets/images/images";



const Filter = ({ setOpen, filtertype, setFilter, isSuggested, filter ,setresult  }) => {
    // Marketplace module gate — ProSchool only (gates rating filter)
    const globalState = useSelector((state) => state.globalState);
    const isMarketplace = globalState?.enabled_modules?.includes('marketplace');

  const [subjects, setsubjects] = useState([]);
  const [data, setData] = useState(null);
  const [count, setCount] = useState(0)

  // Subject states
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const { token } = useAuth();
  const [showAllChips, setShowAllChips] = useState(false);


  //browse by state
  const [browseCourses, setbrowseCourses] = useState(false)
  const [browseTutors, setbrowseTutors] = useState(false)

  //courses state 

  const [myCourse, setmyCourse] = useState(false)
  const [suggestedCourse, setsuggestedCourse] = useState(false)

  //pricing state
  const [freeCourse, setfreeCourse] = useState(false)
  const [paidCourse, setpaidCourse] = useState(false)

  //course status state
  const [activeCourse, setactiveCourse] = useState(false)
  const [completedCourse, setcompletedCourse] = useState(false)
  const [requestedCourse, setrequestedCourse] = useState(false)
  const [expiredCourse, setexpiredCourse] = useState(false)

  //rating state
  const [fourStarPlus, setfourStarPlus] = useState(false)
  const [threeStarPlus, setthreeStarPlus] = useState(false)

  const [visibleDropdownCount, setVisibleDropdownCount] = useState(4);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSubjectDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef, setSubjectDropdownOpen]);

  const toggleSubject = (subject) => {
    setSelectedSubjects((prev) =>
      prev.includes(subject)
        ? prev.filter((s) => s !== subject)
        : [...prev, subject]
    );
  };

  const handleResetFilter = () => {
    setSelectedSubjects([]);
    setbrowseCourses(false);
    setbrowseTutors(false);
    setmyCourse(false);
    setsuggestedCourse(false);
    setfreeCourse(false);
    setpaidCourse(false);
    setactiveCourse(false);
    setcompletedCourse(false);
    setrequestedCourse(false);
    setexpiredCourse(false);
    setfourStarPlus(false);
    setthreeStarPlus(false);
    setCount(0)
    setresult(null)
    const payload = {
      browse_by: [],
      subjects: [],
      courses: [],
      pricing: [],
      course_status: [],
      ratings: [],
    };

    setFilter(payload);

    setOpen(false);
  }

  const handleApplyFilters = () => {
    const payload = {
      browse_by: [
        browseCourses && "courses",
        browseTutors && "tutors",
      ].filter(Boolean),
      subjects: selectedSubjects,

      courses: [
        myCourse && "my_courses",
        suggestedCourse && "suggested_courses",
      ].filter(Boolean),

      pricing: [
        freeCourse && "free",
        paidCourse && "paid",
      ].filter(Boolean),

      course_status:
        filtertype === "Enrolled"
          ? [
            activeCourse && "active",
            completedCourse && "complete",
            requestedCourse && "requested",
            expiredCourse && "expired",
          ].filter(Boolean)
          : [],

      ratings: [
        fourStarPlus && 4,
        threeStarPlus && 3,
      ].filter(Boolean),
    };


    setFilter(payload);   // send JSON to parent

    setOpen(false);

  };


  const fetchSubjects = async () => {
    //fetch subjects from api
    try {
      const response = await api.get(`/auth/get-datalist/`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });

      const data = response.data;
      setData(data);
      const subjectArray = Object.values(data.subjects);
      setsubjects(subjectArray);
      // console.warn('data', data.subjects);

    } catch (error) {
      console.error("Fetching error:", error);
    } finally {

    }
  }

  const fetchResultCount = async () => {
    //fetch subjects from api

    try {
      const payload = {
        search: search,
        browse_by: currentFilters.browse_by,
        subject: currentFilters.subjects,
        courses: currentFilters.courses,
        pricing: currentFilters.pricing,
        course_status: currentFilters.course_status,
        ratings: currentFilters.ratings,
      };

      if (isSuggested === true) {
        payload.view_all = "all";
      }

      const response = await api.post(
        `courses/student/my-courses-dashboard/v2/count/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const data = response?.data;
      setCount(data);
      setresult(data)  //bb

    } catch (error) {
      console.error("Fetching error:", error);
    } finally {

    }
  }

  useEffect(() => {
    fetchSubjects()
  }, []);


  // Inside your component, add this after all state declarations:

  const currentFilters = useMemo(() => (
    {
      browse_by: [
        browseCourses && "courses",
        browseTutors && "tutors",
      ].filter(Boolean),
      subjects: selectedSubjects,
      courses: [
        myCourse && "my_courses",
        suggestedCourse && "suggested_courses",
      ].filter(Boolean),
      pricing: [
        freeCourse && "free",
        paidCourse && "paid",
      ].filter(Boolean),
      course_status: filtertype === "Enrolled"
        ? [
          activeCourse && "active",
          completedCourse && "complete",
          requestedCourse && "requested",
          expiredCourse && "expired",
        ].filter(Boolean)
        : [],
      ratings: [
        fourStarPlus && 4,
        threeStarPlus && 3,
      ].filter(Boolean),
    }), [
    browseCourses, browseTutors,
    selectedSubjects, myCourse, suggestedCourse,
    freeCourse, paidCourse, activeCourse, completedCourse,
    requestedCourse, expiredCourse, fourStarPlus, threeStarPlus, filtertype
  ]);

  const isFilterEmpty = useMemo(() => {
    return (
      currentFilters.browse_by.length === 0 &&
      currentFilters.subjects.length === 0 &&
      currentFilters.courses.length === 0 &&
      currentFilters.pricing.length === 0 &&
      currentFilters.course_status.length === 0 &&
      currentFilters.ratings.length === 0
    );
  }, [currentFilters]);


  //const isFirstRender = useRef(true);
    // useEffect(() => { //bug :PR1-I1319
    
  //     if (isFirstRender.current) {
  //   isFirstRender.current = false;
  //   return;
  // }

  //   if (isFilterEmpty) {
  //     setCount(0);
  //     setFilter({                    // ← add this
  //       // subjects: [],
  //       courses: [],
  //       pricing: [],
  //       course_status: [],
  //       ratings: [],
  //     });
  //     return;
  //   }
  //   fetchResultCount()
  // }, [currentFilters])


  const hadFilters = useRef(false);
  useEffect(() => {
  // If filters are applied
  if (!isFilterEmpty) {
    hadFilters.current = true;
    fetchResultCount();
    return;
  }

  // Only reset if user previously had filters
  if (hadFilters.current && isFilterEmpty) {
    setCount(0);
    setresult(null)  //bb

    setFilter({
      browse_by: [],
      subjects: [],
      courses: [],
      pricing: [],
      course_status: [],
      ratings: [],
    });

    hadFilters.current = false;
  }
}, [currentFilters]);


//og
//   useEffect(() => { //bug :PR1-I1319
//   if (isFilterEmpty) {
//     setCount(0);
//     return;
//   }

//   fetchResultCount();
// }, [currentFilters]);

  const visibleChips = showAllChips
    ? selectedSubjects
    : selectedSubjects.slice(0, 1);
  const extraCount = selectedSubjects.length - visibleChips.length;

  const filteredSubjects = subjects.filter((s) =>
    s.toLowerCase().includes(search.toLowerCase())
  );

  // Determine if sections should be disabled

  //bb
  // const isPricingDisabled = myCourse;
  // const isCourseStatusDisabled = suggestedCourse;


  //bb new
  const noCourseSelected = !myCourse && !suggestedCourse;
const bothCoursesSelected = myCourse && suggestedCourse;

// NEW: true when either Browse By option is active
const isBrowseBySelected = browseCourses || browseTutors;

// Browse By selection now enables Pricing;
// otherwise the original rule (isSuggested / noCourseSelected / myCourse-only) still applies unchanged
const isPricingDisabled = isBrowseBySelected
  ? false
  : isSuggested
    ? false
    : noCourseSelected || (!bothCoursesSelected && myCourse);

const isCourseStatusDisabled = noCourseSelected || (!bothCoursesSelected && suggestedCourse);

// Disable Courses section when either Courses or Tutors is selected from Browse By
const isCourseSectionDisabled = browseCourses || browseTutors;

// Disable Browse By section when either My Courses or Suggested Courses is selected
const isBrowseByDisabled = myCourse || suggestedCourse;

  return (
    // <div className={`drawer ${open ? "open" : ""}`}>
    //     {/* HEADER */}
    //     <div className="drawer-header">
    //         <h3>Filter</h3>
    //         <button className="close-btn" onClick={() => setOpen(false)}>
    //             ✕
    //         </button>
    //     </div>

    <div className="drawer-body">
      {/* SUBJECTS */}
      <div className="filter-sectionB" ref={dropdownRef}>
        <div className="section-header">
          <label>Subjects ({selectedSubjects.length})</label>
          <button disabled={selectedSubjects.length === 0} style={{ fontSize: "14px", color: "#0068FF", background: "transparent", border: "none", opacity: selectedSubjects.length === 0 ? "0.5" : "1" }} onClick={() => setSelectedSubjects([])}>
            Clear
          </button>
        </div>

        {/* SELECT SUBJECT (WITH CHIPS INSIDE) */}
        <div
          className={`subject-select ${subjectDropdownOpen ? "active" : ""}`}
          onClick={() => setSubjectDropdownOpen((prev) => !prev)}
        >
          {selectedSubjects.length === 0 ? (
            <span>Select Subject</span>
          ) : (
            <div className="chips-inline">
              {visibleChips.map((subject) => (
                <div className="chip" key={subject}>
                  {subject}
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSubject(subject);
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
              {extraCount > 0 && !showAllChips && (
                <div
                  className="chip more-chip"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllChips(true);
                  }}
                >
                  + {extraCount} more
                </div>
              )}
              {showAllChips && selectedSubjects.length > 2 && (
                <div
                  className="chip more-chip"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllChips(false);
                  }}
                >
                  Show less
                </div>
              )}
            </div>
          )}
          <span className={`arrow ${subjectDropdownOpen ? "up" : ""}`}>
            ⌃
          </span>
        </div>

        {/* DROPDOWN LIST */}
        <div>
            {subjectDropdownOpen && (
  //             <div className="subject-dropdown">
  //               <input
  //                 className="search-inputB"
  //                 placeholder="Search..."
  //                 value={search}
  //                 onChange={(e) => {setSearch(e.target.value.trimStart())
  //                   setVisibleDropdownCount(4); 
  //                 }

  //                 }
  //               />
  //               {filteredSubjects.map((subject) => (
  //                 <label key={subject}>
  //                   <input
  //                     type="checkbox"
  //                     checked={selectedSubjects.includes(subject)}
  //                     onChange={() => toggleSubject(subject)}
  //                   />
  //                   {subject.trim()}
  //                 </label>
  //               ))}
  // {filteredSubjects.length > visibleDropdownCount && (
  //   <div className="more" onClick={() => setVisibleDropdownCount((prev) => prev + 4)}>
  //     + {filteredSubjects.length - visibleDropdownCount} more
  //   </div>
  // )}

  // {visibleDropdownCount > 4 && (
  //   <div className="more" onClick={() => setVisibleDropdownCount(4)}>
  //     Show less
  //   </div>
  // )}              </div>
  <div className="subject-dropdown">
  <input
    className="search-inputB"
    placeholder="Search..."
    value={search}
    onChange={(e) => {
      setSearch(e.target.value.trimStart());
      setVisibleDropdownCount(4);
    }}
  />
  <div className="dropdown-subjects-list">
    {filteredSubjects.slice(0, visibleDropdownCount).map((subject) => (
      <label key={subject}>
        <input
          type="checkbox"
          checked={selectedSubjects.includes(subject)}
          onChange={() => toggleSubject(subject)}
        />
        {subject.trim()}
      </label>
    ))}
  </div>

    {/* More button */}
    {filteredSubjects.length > visibleDropdownCount && (
      <div
        className="more"
        style={{color:"#0068FF" , cursor:"pointer", fontSize:"13px"}}
        onClick={() => setVisibleDropdownCount((prev) => prev + 4)}
      >
        Show more ({filteredSubjects.length - visibleDropdownCount})
      </div>
    )}

    {/* Show less — only when expanded beyond 4 */}
    {visibleDropdownCount > 4 && (
      <div
        className="more"
        style={{cursor:"pointer", fontSize:"13px"}}
        onClick={() => setVisibleDropdownCount(4)}
      >
        Show less
      </div>
    )}
  </div>
            )}
          </div>

      </div>

      {/* BROWSE BY */}
      <div className={`filter-sectionB ${isBrowseByDisabled ? 'disabled' : ''}`}>
        <strong>Browse By</strong>
        <label>
          <input
            type="checkbox"
            checked={browseCourses}
            disabled={isBrowseByDisabled}
            onChange={(e) => {
              setbrowseCourses(e.target.checked);
              // Clear Courses section when either browse option is selected
              if (e.target.checked || browseTutors) {
                setmyCourse(false);
                setsuggestedCourse(false);
                setfreeCourse(false);
                setpaidCourse(false);
                setactiveCourse(false);
                setcompletedCourse(false);
                setrequestedCourse(false);
                setexpiredCourse(false);
              }
            }}
          />
          Courses
        </label>
        <label>
          <input
            type="checkbox"
            checked={browseTutors}
            disabled={isBrowseByDisabled}
            onChange={(e) => {
              setbrowseTutors(e.target.checked);
              // Clear Courses section when either browse option is selected
              if (e.target.checked || browseCourses) {
                setmyCourse(false);
                setsuggestedCourse(false);
                setfreeCourse(false);
                setpaidCourse(false);
                setactiveCourse(false);
                setcompletedCourse(false);
                setrequestedCourse(false);
                setexpiredCourse(false);
              }
            }}
          />
          Tutors
        </label>
      </div>

      {/* COURSES */}
      {!isSuggested && (
        <div className={`filter-sectionB ${isCourseSectionDisabled ? 'disabled' : ''}`}>
          <strong>Courses</strong>
          <label>
            <input
              type="checkbox"
              checked={myCourse}
              disabled={isCourseSectionDisabled}
              // onChange={(e) => {
              //   setmyCourse(e.target.checked);
              //   // if (e.target.checked) setsuggestedCourse(false); // ✅ uncheck sibling
              //   setfreeCourse(false);
              //   setpaidCourse(false);
              // }}

              onChange={(e) => {
  setmyCourse(e.target.checked);
  if (e.target.checked) {
    // Clear Browse By when Courses section is selected
    setbrowseCourses(false);
    setbrowseTutors(false);
  }
  if (!e.target.checked && !suggestedCourse) {
    // Both now unchecked — clear everything
    setfreeCourse(false);
    setpaidCourse(false);
    setactiveCourse(false);
    setcompletedCourse(false);
    setrequestedCourse(false);
    setexpiredCourse(false);
  } else {
    setfreeCourse(false);
    setpaidCourse(false);
  }
}}
            />
            My Courses
          </label>
          <label>
            <input
              type="checkbox"
              checked={suggestedCourse}
              disabled={isCourseSectionDisabled}
              // onChange={(e) => {
              //   setsuggestedCourse(e.target.checked);
              //   // if (e.target.checked) setmyCourse(false); // ✅ uncheck sibling
              //   setactiveCourse(false);
              //   setcompletedCourse(false);
              //   setrequestedCourse(false);
              //   setexpiredCourse(false);
              // }}

              onChange={(e) => {
  setsuggestedCourse(e.target.checked);
  if (e.target.checked) {
    // Clear Browse By when Courses section is selected
    setbrowseCourses(false);
    setbrowseTutors(false);
  }
  if (!e.target.checked && !myCourse) {
    setfreeCourse(false);
    setpaidCourse(false);
    setactiveCourse(false);
    setcompletedCourse(false);
    setrequestedCourse(false);
    setexpiredCourse(false);
  } else {
    setactiveCourse(false);
    setcompletedCourse(false);
    setrequestedCourse(false);
    setexpiredCourse(false);
  }
}}
            />
            Suggested Courses
          </label>
        </div>
      )}

      {/* PRICING */}
      <div
        className={`filter-sectionB ${isPricingDisabled ? "disabled" : ""}`}
      >
        <strong>Pricing</strong>
        <label>
          <input
            type="checkbox"
            checked={freeCourse}
             disabled={isPricingDisabled}   //bb
            onChange={(e) => setfreeCourse(e.target.checked)}
          />
          Free Courses
        </label>
        <label>
          <input
            type="checkbox"
            checked={paidCourse}
            disabled={isPricingDisabled}   //bb
            onChange={(e) => setpaidCourse(e.target.checked)}
          />
          Paid Courses
        </label>
      </div>

      {/* COURSE STATUS */}
      {!isSuggested && (
        <div
          className={`filter-sectionB ${isCourseStatusDisabled ? "disabled" : ""
            }`}
        >
          <strong>Course Status</strong>
          {filtertype === "Enrolled" ? (
            <>
              <label>
                <input
                  type="checkbox"
                  checked={activeCourse}
                  disabled={isCourseStatusDisabled} //bb
                  onChange={(e) => setactiveCourse(e.target.checked)}
                />
                Active Courses
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={completedCourse}
                  disabled={isCourseStatusDisabled} //bb
                  onChange={(e) => setcompletedCourse(e.target.checked)}
                />
                Completed Courses
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={requestedCourse}
                  disabled={isCourseStatusDisabled} //bb
                  onChange={(e) => setrequestedCourse(e.target.checked)}
                />
                Requested Courses
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={expiredCourse}
                  disabled={isCourseStatusDisabled} //bb
                  onChange={(e) => setexpiredCourse(e.target.checked)}
                />
                Expired Courses
              </label>
            </>
          ) : (
            <>
              <label>
                <input
                  type="checkbox"
                  checked={freeCourse}
                  onChange={(e) => setfreeCourse(e.target.checked)}
                />
                Free Courses
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={paidCourse}
                  onChange={(e) => setpaidCourse(e.target.checked)}
                />
                Paid Courses
              </label>
            </>
          )}
        </div>
      )}

        {/* RATINGS — ProSchool (marketplace) only */}
        {isMarketplace && (
          <div className="filter-sectionB">
            <strong>Ratings</strong>
            <label>
              <input
                type="checkbox"
                checked={fourStarPlus}
                onChange={(e) => setfourStarPlus(e.target.checked)}
              />
              4 ★ & Above
            </label>
            <label>
              <input
                type="checkbox"
                checked={threeStarPlus}
                onChange={(e) => setthreeStarPlus(e.target.checked)}
              />
              3 ★ & Above
            </label>
          </div>
        )}

      {/* Results */}
      {/* <div className="filter-results">
        <label>
          Results:{""}({count?.result_count || 0})
        </label>
      </div> */}
      {/* FOOTER */}
      <div className="filter-footer">
        <button
          className="reset"
          disabled={isFilterEmpty}
          onClick={handleResetFilter}
          style={{
            opacity: isFilterEmpty ? 0.5 : 1,
            color: isFilterEmpty ? "#999" : "#2563EB",
          }}
        >
          Reset Filter
          <span>
            <img src={autorenew} alt="Reset Filter" />
          </span>
        </button>
        <button
          className="apply"
          disabled={isFilterEmpty}
          onClick={handleApplyFilters}
          style={{
            opacity: isFilterEmpty ? 0.5 : 1,
            color: isFilterEmpty ? "#999" : "white",
          }}
        >
          Apply Filters
          <span>
            <img src={arrowForward} alt="Arrow Forward" />
          </span>
        </button>
      </div>
    </div>
  );
};
export default Filter;